var Admin__OrganizationProfile__SchemasController;

import ProfilesForm from 'trunks/vue/admin/components/organizations/profiles/form.js';

export default Admin__OrganizationProfile__SchemasController = class Admin__OrganizationProfile__SchemasController extends Skylark.App.BaseController {
  show() {
    var el, fields, form, ref;
    fields = (ref = this.getVars('schema')) != null ? ref.fields : void 0;
    form = new Skylark.App.Model.Form({
      title: '未命名表单',
      description: '',
      fields: fields,
      attachments: []
    });
    el = Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('profiles_edit');
    return this._profilesVm = new ProfilesForm({
      el: el,
      data: {
        form: form
      }
    });
  }

};
